import styled from 'styled-components';
import { useExperiment } from '../../../../../../common/ExperimentContext/useExperiment';
import { SearchResultPractitioner } from '../../../../../types';
import { CollapsingValue } from './CollapsingValue/CollapsingValue';
import { Detail } from './Detail/Detail';
import { ShowPractitionerSpecialInterestsExperiment } from './ShowPractitionerSpecialInterestsExperiment';
import { Tag } from './Tag/Tag';
import Star from './assets/Star.svg';

interface Props {
  practitioner: SearchResultPractitioner;
}

export const PractitionerDetails = ({ practitioner }: Props) => {
  const { interests, bulkBilling } = practitioner;

  const experimentData = useExperiment(ShowPractitionerSpecialInterestsExperiment);

  const showPractitionerSpecialInterests = experimentData.data;

  return (
    <View>
      {bulkBilling && <Tag>Bulk Billing</Tag>}
      {showPractitionerSpecialInterests && (
        <Detail label="Special interests" icon={Star} notProvided={interests.length === 0}>
          <CollapsingValue values={interests} />
        </Detail>
      )}
    </View>
  );
};

const View = styled.div`
  width: 100%;
`;
